import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { CommonService } from '../../app/services/common.service';
import { ReportDownloadService } from './report.download.service';
import { BindComponentService } from '../utils/bind.component.service';
import { DataPackGroup } from '../models/start';
/**
 * @version $Id$
 */
@Injectable()
export class VivoSyncService extends CommonService {
  private localURL: string;

  private VIVO_SYNC_PATH: string = '/datapackvivosync';

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService,public reportDownloadService: ReportDownloadService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.VIVO_SYNC_PATH;
  }

  public loadView(startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=loadView';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize; 
    }
    return this.convertResponse(this.httpGet(url));
  }

  public loadViewVivoSync(startRow: number, fetchSize: number) {
     return this.convertResponse(this.httpPost(this.localURL,{action:'loadViewVivoSync',startRow:startRow,fetchSize:fetchSize}));
  }

  public listGroups(startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=listGroups';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public listGroupsBlockVoice(startRow: number, fetchSize: number) {
    return this.convertResponse(this.httpPost(this.localURL, {startRow:startRow,fetchSize:fetchSize}));
  }

  public listLines(group: DataPackGroup, startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=listLines'
    if(group) {
      url += '&groupId=' + group.id;
    }
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));;
  }

  public activateLines(payload: any) {
    return this.convertResponse(this.httpPost(this.localURL + '?action=activateLines', payload));
  }

  public deactivateLines(payload: any) {
    return this.convertResponse(this.httpPost(this.localURL + '?action=deactivateLines', payload));
  }

  public loadingLines(group:DataPackGroup,startRow: number, fetchSize: number) {
    return this.convertResponse(this.httpPost(this.localURL,{group:group,action:'loadLinesVivoSync',startRow:startRow,fetchSize:fetchSize}));
  }

  public loadGroupFilterVoice(group:DataPackGroup,startRow: number, fetchSize: number) {
    return this.loadGroupFilter(group, startRow, fetchSize, false);
  }

  public loadGroupFilterData(group:DataPackGroup,startRow: number, fetchSize: number) {
    return this.loadGroupFilter(group, startRow, fetchSize, true);
  }

  public loadGroupFilter(group:DataPackGroup,startRow: number, fetchSize: number, dataContext: boolean) {
    return this.convertResponse(this.httpPost(this.localURL,{group:group,action:'loadSelectedLineAndGroup',startRow:startRow,fetchSize:fetchSize,dataContext:dataContext}));
  }

  public loadControlStatus() {
    return this.convertResponse(this.httpGet(this.localURL + '?action=loadControlStatus'));
  }

  public loadQueueStatus() {
    return this.convertResponse(this.httpGet(this.localURL + '?action=loadQueueStatus'));
  }

  public generateReport(group: DataPackGroup) {
    let url = this.localURL + '?action=reportVivoSyncStatus';
    url += '&groupId=' + group.id;
    url += '&groupName=' + group.name;
    this.reportDownloadService.prepare(url);
  }

  public getVivoSyncLoadInfo(){
    return this.convertResponse(this.httpGet(this.localURL + '?action=reportVivoSyncLoaderInfo'));
  }

}


// WEBPACK FOOTER //
// ./src/app/services/vivo.sync.service.ts